export default {
  save: 'Save',
  cancel: 'Cancel',
  loading: 'Loading...',
  notNow: 'Not Now',
  error: 'Error',
  error_occurred: 'An error occurred',
  success: 'Success',
  warning: 'Warning',
  info: 'Info',
  confirm: 'Confirm',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  apply: 'Apply',
  saveSuccess: 'Saved successfully',
  saveError: 'Failed to save',
  deleteSuccess: 'Deleted successfully',
  deleteError: 'Failed to delete',
  uploadSuccess: 'Uploaded successfully',
  uploadError: 'Failed to upload',
  fetchError: 'Failed to fetch data',
  page: 'Page',
  of: 'of',
  notProvided: 'Not provided',
  notAvailable: 'Not available',
  backToResources: 'Back to Resources',
  backToBorrowings: 'Back to Borrowings',
  backToList: 'Back to List',
  goBack: 'Go Back',
  create: 'Create',
  update: 'Update',
  actions: 'Actions',
  retry: 'Retry',
  saving: 'Saving...',
  deleting: 'Deleting...',
  noImage: 'No Image',
  images: 'Images',
  moreOptions: 'More options',
  not_specified: 'Not specified',

  // Error management system translations
  networkError: 'Network error. Please check your connection.',
  badRequest: 'Invalid request data',
  unauthorized: 'Authentication required',
  forbidden: 'Access denied',
  notFound: 'Resource not found',
  conflict: 'Conflict with existing data',
  payloadTooLarge: 'File or data too large',
  validationError: 'Please check your input',
  tooManyRequests: 'Too many requests. Please try again later.',
  serverError: 'Server error. Please try again later.',
  serviceUnavailable: 'Service temporarily unavailable',
  unexpectedError: 'Unexpected error occurred',
};
